import { variantShadow } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/shared/variantUtils';
import styled, { CSSProperties } from 'styled-components';

interface VariantCharactersProps {
    characters: string;
    style?: CSSProperties;
    className?: string;
}

export const VariantCharacters = (props: VariantCharactersProps) => {
    const more = props.characters.length >= 3;

    return (
        <S_VariantCharacters className={props.className} style={props.style}>
            {more && (
                <S_Small>
                    {props.characters.slice(0, 3)}
                    {props.characters.length > 3 && <S_Ellipsis>...</S_Ellipsis>}
                </S_Small>
            )}
            {!more && props.characters}
        </S_VariantCharacters>
    );
};

const S_VariantCharacters = styled.div`
    width: 30px;
    height: 30px;
    background-color: ${({ theme }) => theme.colors.white};
    font-family: ${({ theme }) => theme.fonts.semiBold};
    box-shadow: ${variantShadow};
    font-size: 13px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;

const S_Small = styled.span`
    font-size: 11px;
`;

const S_Ellipsis = styled.span`
    font-size: 9px;
`;
